import { render, staticRenderFns } from "./LexicalEditor.vue?vue&type=template&id=1c2fe710&scoped=true"
import script from "./LexicalEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./LexicalEditor.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./LexicalEditor.vue?vue&type=style&index=0&id=1c2fe710&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2fe710",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c2fe710')) {
      api.createRecord('1c2fe710', component.options)
    } else {
      api.reload('1c2fe710', component.options)
    }
    module.hot.accept("./LexicalEditor.vue?vue&type=template&id=1c2fe710&scoped=true", function () {
      api.rerender('1c2fe710', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/proofreading/revising/LexicalEditor.vue"
export default component.exports